// EV-LEK Theme JS

// ── EV Finder ────────────────────────────────────────────────────────────────
(function () {

  // EV database: make → models → charging specs
  var hfcCars = [
    { make: 'audi', label: 'Audi', models: [
      { name: 'A3 e-tron',      from: 2014, to: 2018, connector: 'Type 2',        maxKw: 3.3,  maxAmps: '16A (1-phase)', battery: 8.8,  search: 'Audi A3 e-tron',
        speeds: [{kw:2.3,amps:'10A',time:'~4 hrs'},{kw:3.3,amps:'16A',time:'~3 hrs'}] },
      { name: 'Q3 TFSI e',      from: 2020, to: 9999, connector: 'Type 2',        maxKw: 3.6,  maxAmps: '16A (1-phase)', battery: 13,   search: 'Audi Q3',
        speeds: [{kw:2.3,amps:'10A',time:'~6 hrs'},{kw:3.6,amps:'16A',time:'~4 hrs'}] },
      { name: 'Q4 e-tron',      from: 2021, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 82,   search: 'Audi Q4 e-tron',
        speeds: [{kw:7.4,amps:'32A',time:'~11 hrs'},{kw:11,amps:'16A (3-phase)',time:'~8 hrs'}] },
      { name: 'Q5 TFSI e',      from: 2021, to: 9999, connector: 'Type 2',        maxKw: 7.4,  maxAmps: '32A (1-phase)', battery: 14.4, search: 'Audi Q5',
        speeds: [{kw:2.3,amps:'10A',time:'~7 hrs'},{kw:7.4,amps:'32A',time:'~2 hrs'}] },
      { name: 'Q8 e-tron',      from: 2023, to: 9999, connector: 'Type 2 + CCS',  maxKw: 22,   maxAmps: '32A (3-phase)', battery: 114,  search: 'Audi Q8 e-tron',
        speeds: [{kw:7.4,amps:'32A',time:'~15 hrs'},{kw:22,amps:'32A (3-phase)',time:'~5 hrs'}] }
    ]},
    { make: 'bmw', label: 'BMW', models: [
      { name: '330e',            from: 2019, to: 9999, connector: 'Type 2',        maxKw: 3.7,  maxAmps: '16A (1-phase)', battery: 17.8, search: 'BMW 330e',
        speeds: [{kw:2.3,amps:'10A',time:'~8 hrs'},{kw:3.7,amps:'16A',time:'~5 hrs'}] },
      { name: '530e',            from: 2021, to: 9999, connector: 'Type 2',        maxKw: 3.7,  maxAmps: '16A (1-phase)', battery: 17.7, search: 'BMW 530e',
        speeds: [{kw:2.3,amps:'10A',time:'~8 hrs'},{kw:3.7,amps:'16A',time:'~5 hrs'}] },
      { name: 'iX',              from: 2021, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 111,  search: 'BMW iX',
        speeds: [{kw:7.4,amps:'32A',time:'~15 hrs'},{kw:11,amps:'16A (3-phase)',time:'~10 hrs'}] },
      { name: 'iX3',             from: 2021, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 80,   search: 'BMW iX3',
        speeds: [{kw:7.4,amps:'32A',time:'~11 hrs'},{kw:11,amps:'16A (3-phase)',time:'~7 hrs'}] },
      { name: 'X5 xDrive50e',   from: 2023, to: 9999, connector: 'Type 2',        maxKw: 7.4,  maxAmps: '32A (1-phase)', battery: 25.7, search: 'BMW X5 50e',
        speeds: [{kw:2.3,amps:'10A',time:'~11 hrs'},{kw:7.4,amps:'32A',time:'~3.5 hrs'}] }
    ]},
    { make: 'byd', label: 'BYD', models: [
      { name: 'Atto 3 Evo',     from: 2022, to: 9999, connector: 'Type 2 + CCS',  maxKw: 7,    maxAmps: '32A (1-phase)', battery: 60.5, search: 'BYD Atto 3',
        speeds: [{kw:2.3,amps:'10A',time:'~26 hrs'},{kw:7,amps:'32A',time:'~9 hrs'}] },
      { name: 'Dolphin',         from: 2023, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 44.9, search: 'BYD Dolphin',
        speeds: [{kw:7.4,amps:'32A',time:'~6 hrs'},{kw:11,amps:'16A (3-phase)',time:'~4 hrs'}] },
      { name: 'Seal U DM-i',    from: 2024, to: 9999, connector: 'Type 2',        maxKw: 6.6,  maxAmps: '32A (1-phase)', battery: 15.2, search: 'BYD Seal U',
        speeds: [{kw:2.3,amps:'10A',time:'~7 hrs'},{kw:6.6,amps:'32A',time:'~2.5 hrs'}] },
      { name: 'Sealion 7',       from: 2024, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 71.8, search: 'BYD Sealion 7',
        speeds: [{kw:7.4,amps:'32A',time:'~10 hrs'},{kw:11,amps:'16A (3-phase)',time:'~7 hrs'}] }
    ]},
    { make: 'citroen', label: 'Citroën', models: [
      { name: 'ë-C4',            from: 2021, to: 9999, connector: 'Type 2 + CCS',  maxKw: 7.4,  maxAmps: '32A (1-phase)', battery: 50,   search: 'Citroen eC4',
        speeds: [{kw:2.3,amps:'10A',time:'~22 hrs'},{kw:7.4,amps:'32A',time:'~7 hrs'}] },
      { name: 'ë-C4 X',          from: 2023, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 54,   search: 'Citroen eC4 X',
        speeds: [{kw:7.4,amps:'32A',time:'~7.5 hrs'},{kw:11,amps:'16A (3-phase)',time:'~5 hrs'}] },
      { name: 'C5 Aircross PHEV',from: 2021, to: 9999, connector: 'Type 2',        maxKw: 7.4,  maxAmps: '32A (1-phase)', battery: 13.2, search: 'Citroen C5 Aircross',
        speeds: [{kw:2.3,amps:'10A',time:'~6 hrs'},{kw:7.4,amps:'32A',time:'~2 hrs'}] }
    ]},
    { make: 'tesla', label: 'Tesla', models: [
      { name: 'Model 3',         from: 2019, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 75,   search: 'Tesla Model 3',
        speeds: [{kw:7.4,amps:'32A',time:'~10 hrs'},{kw:11,amps:'16A (3-phase)',time:'~7 hrs'}] },
      { name: 'Model Y',         from: 2022, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 75,   search: 'Tesla Model Y',
        speeds: [{kw:7.4,amps:'32A',time:'~10 hrs'},{kw:11,amps:'16A (3-phase)',time:'~7 hrs'}] },
      { name: 'Model S',         from: 2014, to: 9999, connector: 'Type 2 + CCS',  maxKw: 22,   maxAmps: '32A (3-phase)', battery: 100,  search: 'Tesla Model S',
        speeds: [{kw:11,amps:'16A (3-phase)',time:'~9 hrs'},{kw:22,amps:'32A (3-phase)',time:'~5 hrs'}] },
      { name: 'Model X',         from: 2016, to: 9999, connector: 'Type 2 + CCS',  maxKw: 22,   maxAmps: '32A (3-phase)', battery: 100,  search: 'Tesla Model X',
        speeds: [{kw:11,amps:'16A (3-phase)',time:'~9 hrs'},{kw:22,amps:'32A (3-phase)',time:'~5 hrs'}] }
    ]},
    { make: 'volkswagen', label: 'VW', models: [
      { name: 'ID.3',            from: 2020, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 58,   search: 'VW ID.3',
        speeds: [{kw:7.4,amps:'32A',time:'~8 hrs'},{kw:11,amps:'16A (3-phase)',time:'~5.5 hrs'}] },
      { name: 'ID.4',            from: 2021, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 77,   search: 'VW ID.4',
        speeds: [{kw:7.4,amps:'32A',time:'~10 hrs'},{kw:11,amps:'16A (3-phase)',time:'~7 hrs'}] },
      { name: 'Golf GTE',        from: 2021, to: 9999, connector: 'Type 2',        maxKw: 3.6,  maxAmps: '16A (1-phase)', battery: 13,   search: 'VW Golf GTE',
        speeds: [{kw:2.3,amps:'10A',time:'~6 hrs'},{kw:3.6,amps:'16A',time:'~4 hrs'}] },
      { name: 'Passat GTE',      from: 2020, to: 9999, connector: 'Type 2',        maxKw: 3.6,  maxAmps: '16A (1-phase)', battery: 13,   search: 'VW Passat GTE',
        speeds: [{kw:2.3,amps:'10A',time:'~6 hrs'},{kw:3.6,amps:'16A',time:'~4 hrs'}] }
    ]},
    { make: 'nissan', label: 'Nissan', models: [
      { name: 'Leaf 40kWh',      from: 2018, to: 9999, connector: 'Type 2 + CHAdeMO', maxKw: 7.4, maxAmps: '32A (1-phase)', battery: 40,  search: 'Nissan Leaf',
        speeds: [{kw:3.7,amps:'16A',time:'~11 hrs'},{kw:7.4,amps:'32A',time:'~5.5 hrs'}] },
      { name: 'Leaf 62kWh',      from: 2019, to: 9999, connector: 'Type 2 + CHAdeMO', maxKw: 7.4, maxAmps: '32A (1-phase)', battery: 62,  search: 'Nissan Leaf',
        speeds: [{kw:3.7,amps:'16A',time:'~17 hrs'},{kw:7.4,amps:'32A',time:'~8.5 hrs'}] },
      { name: 'Ariya',           from: 2023, to: 9999, connector: 'Type 2 + CCS',  maxKw: 22,   maxAmps: '32A (3-phase)', battery: 87,   search: 'Nissan Ariya',
        speeds: [{kw:11,amps:'16A (3-phase)',time:'~8 hrs'},{kw:22,amps:'32A (3-phase)',time:'~4 hrs'}] }
    ]},
    { make: 'hyundai', label: 'Hyundai', models: [
      { name: 'IONIQ 5',         from: 2021, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 77.4, search: 'Hyundai IONIQ 5',
        speeds: [{kw:7.4,amps:'32A',time:'~10.5 hrs'},{kw:11,amps:'16A (3-phase)',time:'~7 hrs'}] },
      { name: 'IONIQ 5 N',       from: 2024, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 84,   search: 'Hyundai IONIQ 5 N',
        speeds: [{kw:7.4,amps:'32A',time:'~11.5 hrs'},{kw:11,amps:'16A (3-phase)',time:'~7.5 hrs'}] },
      { name: 'IONIQ 6',         from: 2023, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 77.4, search: 'Hyundai IONIQ 6',
        speeds: [{kw:7.4,amps:'32A',time:'~10.5 hrs'},{kw:11,amps:'16A (3-phase)',time:'~7 hrs'}] },
      { name: 'IONIQ 9',         from: 2025, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 110,  search: 'Hyundai IONIQ 9',
        speeds: [{kw:7.4,amps:'32A',time:'~15 hrs'},{kw:11,amps:'16A (3-phase)',time:'~10 hrs'}] },
      { name: 'Kona Electric',   from: 2023, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 65.4, search: 'Hyundai Kona Electric',
        speeds: [{kw:7.4,amps:'32A',time:'~8.5 hrs'},{kw:11,amps:'16A (3-phase)',time:'~6 hrs'}] },
      { name: 'Santa Fe PHEV',   from: 2021, to: 9999, connector: 'Type 2',        maxKw: 7.2,  maxAmps: '32A (1-phase)', battery: 13.8, search: 'Hyundai Santa Fe PHEV',
        speeds: [{kw:2.3,amps:'10A',time:'~6 hrs'},{kw:7.2,amps:'32A',time:'~2 hrs'}] },
      { name: 'Tucson PHEV',     from: 2021, to: 9999, connector: 'Type 2',        maxKw: 7.2,  maxAmps: '32A (1-phase)', battery: 13.8, search: 'Hyundai Tucson PHEV',
        speeds: [{kw:2.3,amps:'10A',time:'~6 hrs'},{kw:7.2,amps:'32A',time:'~2 hrs'}] }
    ]},
    { make: 'kia', label: 'Kia', models: [
      { name: 'EV3',             from: 2024, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 58.3, search: 'Kia EV3',
        speeds: [{kw:7.4,amps:'32A',time:'~8 hrs'},{kw:11,amps:'16A (3-phase)',time:'~5.5 hrs'}] },
      { name: 'EV4',             from: 2025, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 64,   search: 'Kia EV4',
        speeds: [{kw:7.4,amps:'32A',time:'~8.5 hrs'},{kw:11,amps:'16A (3-phase)',time:'~6 hrs'}] },
      { name: 'EV5',             from: 2025, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 64,   search: 'Kia EV5',
        speeds: [{kw:7.4,amps:'32A',time:'~8.5 hrs'},{kw:11,amps:'16A (3-phase)',time:'~6 hrs'}] },
      { name: 'EV6',             from: 2022, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 77,   search: 'Kia EV6',
        speeds: [{kw:7.4,amps:'32A',time:'~10 hrs'},{kw:11,amps:'16A (3-phase)',time:'~7 hrs'}] },
      { name: 'EV9',             from: 2024, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 99.8, search: 'Kia EV9',
        speeds: [{kw:7.4,amps:'32A',time:'~13.5 hrs'},{kw:11,amps:'16A (3-phase)',time:'~9 hrs'}] },
      { name: 'Niro EV',         from: 2019, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 64,   search: 'Kia Niro EV',
        speeds: [{kw:7.4,amps:'32A',time:'~8.5 hrs'},{kw:11,amps:'16A (3-phase)',time:'~6 hrs'}] },
      { name: 'Sorento PHEV',    from: 2021, to: 9999, connector: 'Type 2',        maxKw: 7.2,  maxAmps: '32A (1-phase)', battery: 13.8, search: 'Kia Sorento PHEV',
        speeds: [{kw:2.3,amps:'10A',time:'~6 hrs'},{kw:7.2,amps:'32A',time:'~2 hrs'}] },
      { name: 'Sportage PHEV',   from: 2022, to: 9999, connector: 'Type 2',        maxKw: 7.2,  maxAmps: '32A (1-phase)', battery: 13.8, search: 'Kia Sportage PHEV',
        speeds: [{kw:2.3,amps:'10A',time:'~6 hrs'},{kw:7.2,amps:'32A',time:'~2 hrs'}] }
    ]},
    { make: 'land-rover', label: 'Land Rover', models: [
      { name: 'Range Rover Electric',  from: 2025, to: 9999, connector: 'Type 2 + CCS',  maxKw: 22,   maxAmps: '32A (3-phase)', battery: 117,  search: 'Land Rover Range Rover Electric',
        speeds: [{kw:7.4,amps:'32A',time:'~16 hrs'},{kw:11,amps:'16A (3-phase)',time:'~11 hrs'}] },
      { name: 'Range Rover Sport PHEV', from: 2023, to: 9999, connector: 'Type 2',       maxKw: 7.2,  maxAmps: '32A (1-phase)', battery: 31.8, search: 'Land Rover Range Rover Sport PHEV',
        speeds: [{kw:2.3,amps:'10A',time:'~14 hrs'},{kw:7.2,amps:'32A',time:'~4.5 hrs'}] },
      { name: 'Range Rover PHEV',      from: 2022, to: 9999, connector: 'Type 2',        maxKw: 7.2,  maxAmps: '32A (1-phase)', battery: 31.8, search: 'Land Rover Range Rover PHEV',
        speeds: [{kw:2.3,amps:'10A',time:'~14 hrs'},{kw:7.2,amps:'32A',time:'~4.5 hrs'}] },
      { name: 'Defender PHEV',         from: 2021, to: 9999, connector: 'Type 2',        maxKw: 7.2,  maxAmps: '32A (1-phase)', battery: 19.2, search: 'Land Rover Defender PHEV',
        speeds: [{kw:2.3,amps:'10A',time:'~8.5 hrs'},{kw:7.2,amps:'32A',time:'~2.5 hrs'}] },
      { name: 'Evoque PHEV',           from: 2020, to: 9999, connector: 'Type 2',        maxKw: 7.2,  maxAmps: '32A (1-phase)', battery: 15,   search: 'Land Rover Evoque PHEV',
        speeds: [{kw:2.3,amps:'10A',time:'~6.5 hrs'},{kw:7.2,amps:'32A',time:'~2 hrs'}] },
      { name: 'Velar PHEV',            from: 2021, to: 9999, connector: 'Type 2',        maxKw: 7.2,  maxAmps: '32A (1-phase)', battery: 19.2, search: 'Land Rover Velar PHEV',
        speeds: [{kw:2.3,amps:'10A',time:'~8.5 hrs'},{kw:7.2,amps:'32A',time:'~2.5 hrs'}] }
    ]},
    { make: 'mercedes-benz', label: 'Mercedes', models: [
      { name: 'EQA',             from: 2021, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 66.5, search: 'Mercedes EQA',
        speeds: [{kw:7.4,amps:'32A',time:'~9 hrs'},{kw:11,amps:'16A (3-phase)',time:'~6 hrs'}] },
      { name: 'EQB',             from: 2022, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 66.5, search: 'Mercedes EQB',
        speeds: [{kw:7.4,amps:'32A',time:'~9 hrs'},{kw:11,amps:'16A (3-phase)',time:'~6 hrs'}] },
      { name: 'EQC',             from: 2020, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 80,   search: 'Mercedes EQC',
        speeds: [{kw:7.4,amps:'32A',time:'~11 hrs'},{kw:11,amps:'16A (3-phase)',time:'~7.5 hrs'}] },
      { name: 'C 300e',          from: 2022, to: 9999, connector: 'Type 2',        maxKw: 7.4,  maxAmps: '32A (1-phase)', battery: 25.4, search: 'Mercedes C300e',
        speeds: [{kw:2.3,amps:'10A',time:'~11 hrs'},{kw:7.4,amps:'32A',time:'~3.5 hrs'}] }
    ]},
    { make: 'ford', label: 'Ford', models: [
      { name: 'Mustang Mach-E',  from: 2021, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 91,   search: 'Ford Mustang Mach-E',
        speeds: [{kw:7.4,amps:'32A',time:'~12 hrs'},{kw:11,amps:'16A (3-phase)',time:'~8 hrs'}] },
      { name: 'Kuga PHEV',       from: 2020, to: 9999, connector: 'Type 2',        maxKw: 3.7,  maxAmps: '16A (1-phase)', battery: 14.4, search: 'Ford Kuga PHEV',
        speeds: [{kw:2.3,amps:'10A',time:'~6 hrs'},{kw:3.7,amps:'16A',time:'~4 hrs'}] },
      { name: 'Explorer EV',     from: 2024, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 77,   search: 'Ford Explorer EV',
        speeds: [{kw:7.4,amps:'32A',time:'~10 hrs'},{kw:11,amps:'16A (3-phase)',time:'~7 hrs'}] },
      { name: 'Capri Electric',   from: 2024, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 77,   search: 'Ford Capri Electric',
        speeds: [{kw:7.4,amps:'32A',time:'~10 hrs'},{kw:11,amps:'16A (3-phase)',time:'~7 hrs'}] }
    ]},
    { make: 'cupra', label: 'CUPRA', models: [
      { name: 'Born',                    from: 2021, to: 9999, connector: 'Type 2 + CCS', maxKw: 11,  maxAmps: '16A (3-phase)', battery: 58,   search: 'CUPRA Born',
        speeds: [{kw:7.4,amps:'32A',time:'~8 hrs'},{kw:11,amps:'16A (3-phase)',time:'~5.5 hrs'}] },
      { name: 'Tavascan',                from: 2024, to: 9999, connector: 'Type 2 + CCS', maxKw: 11,  maxAmps: '16A (3-phase)', battery: 79,   search: 'CUPRA Tavascan',
        speeds: [{kw:7.4,amps:'32A',time:'~10 hrs'},{kw:11,amps:'16A (3-phase)',time:'~7 hrs'}] },
      { name: 'Formentor e-HYBRID',      from: 2021, to: 9999, connector: 'Type 2',       maxKw: 7.4, maxAmps: '32A (1-phase)', battery: 12.8, search: 'CUPRA Formentor',
        speeds: [{kw:2.3,amps:'10A',time:'~6 hrs'},{kw:7.4,amps:'32A',time:'~2 hrs'}] },
      { name: 'Leon e-HYBRID',           from: 2021, to: 9999, connector: 'Type 2',       maxKw: 7.4, maxAmps: '32A (1-phase)', battery: 12.8, search: 'CUPRA Leon',
        speeds: [{kw:2.3,amps:'10A',time:'~6 hrs'},{kw:7.4,amps:'32A',time:'~2 hrs'}] },
      { name: 'Leon Sportstourer e-HYBRID', from: 2021, to: 9999, connector: 'Type 2',    maxKw: 7.4, maxAmps: '32A (1-phase)', battery: 12.8, search: 'CUPRA Leon Sportstourer',
        speeds: [{kw:2.3,amps:'10A',time:'~6 hrs'},{kw:7.4,amps:'32A',time:'~2 hrs'}] },
      { name: 'Terramar e-HYBRID',       from: 2024, to: 9999, connector: 'Type 2',       maxKw: 3.7, maxAmps: '16A (1-phase)', battery: 14.1, search: 'CUPRA Terramar',
        speeds: [{kw:2.3,amps:'10A',time:'~6 hrs'},{kw:3.7,amps:'16A',time:'~4 hrs'}] }
    ]},
    { make: 'ds', label: 'DS Automobiles', models: [
      { name: 'DS 3 E-TENSE',          from: 2021, to: 9999, connector: 'Type 2 + CCS', maxKw: 11,  maxAmps: '16A (3-phase)', battery: 54,   search: 'DS 3 E-TENSE',
        speeds: [{kw:7.4,amps:'32A',time:'~7.5 hrs'},{kw:11,amps:'16A (3-phase)',time:'~5 hrs'}] },
      { name: 'DS N°4 E-TENSE PHEV',   from: 2022, to: 9999, connector: 'Type 2',       maxKw: 7.4, maxAmps: '32A (1-phase)', battery: 12.4, search: 'DS 4 E-TENSE',
        speeds: [{kw:2.3,amps:'10A',time:'~6 hrs'},{kw:7.4,amps:'32A',time:'~2 hrs'}] },
      { name: 'DS 7 Plug-in Hybrid',   from: 2019, to: 9999, connector: 'Type 2',       maxKw: 7.4, maxAmps: '32A (1-phase)', battery: 14.2, search: 'DS 7 E-TENSE',
        speeds: [{kw:2.3,amps:'10A',time:'~6.5 hrs'},{kw:7.4,amps:'32A',time:'~2 hrs'}] },
      { name: 'DS 9 Plug-in Hybrid',   from: 2021, to: 9999, connector: 'Type 2',       maxKw: 7.4, maxAmps: '32A (1-phase)', battery: 15.6, search: 'DS 9 E-TENSE',
        speeds: [{kw:2.3,amps:'10A',time:'~7 hrs'},{kw:7.4,amps:'32A',time:'~2 hrs'}] },
      { name: 'DS N°8 Electric',        from: 2024, to: 9999, connector: 'Type 2 + CCS', maxKw: 11,  maxAmps: '16A (3-phase)', battery: 74,   search: 'DS 8 Electric',
        speeds: [{kw:7.4,amps:'32A',time:'~10 hrs'},{kw:11,amps:'16A (3-phase)',time:'~7 hrs'}] }
    ]},
    { make: 'fiat', label: 'Fiat', models: [
      { name: 'Fiat 500e', from: 2020, to: 9999, connector: 'Type 2', maxKw: 11, maxAmps: '16A (3-phase)', battery: 42, search: 'Fiat 500e',
        speeds: [{kw:7.4,amps:'32A',time:'~6 hrs'},{kw:11,amps:'16A (3-phase)',time:'~4 hrs'}] },
      { name: 'Fiat 600e', from: 2023, to: 9999, connector: 'Type 2 + CCS', maxKw: 11, maxAmps: '16A (3-phase)', battery: 54, search: 'Fiat 600e',
        speeds: [{kw:7.4,amps:'32A',time:'~8 hrs'},{kw:11,amps:'16A (3-phase)',time:'~5.5 hrs'}] }
    ]},
    { make: 'jeep', label: 'Jeep', models: [
      { name: 'Avenger Electric', from: 2023, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,  maxAmps: '16A (3-phase)', battery: 51,  search: 'Jeep Avenger Electric',
        speeds: [{kw:7.4,amps:'32A',time:'~7 hrs'},{kw:11,amps:'16A (3-phase)',time:'~5 hrs'}] },
      { name: 'Compass Electric', from: 2024, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,  maxAmps: '16A (3-phase)', battery: 54,  search: 'Jeep Compass Electric',
        speeds: [{kw:7.4,amps:'32A',time:'~7.5 hrs'},{kw:11,amps:'16A (3-phase)',time:'~5 hrs'}] }
    ]},
    { make: 'honda', label: 'Honda', models: [
      { name: 'e',           from: 2020, to: 2024, connector: 'Type 2',        maxKw: 7.4,  maxAmps: '32A (1-phase)', battery: 28.5, search: 'Honda e',
        speeds: [{kw:2.3,amps:'10A',time:'~12 hrs'},{kw:7.4,amps:'32A',time:'~4 hrs'}] },
      { name: 'e:Ny1',       from: 2023, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 68.8, search: 'Honda eNy1',
        speeds: [{kw:7.4,amps:'32A',time:'~9.5 hrs'},{kw:11,amps:'16A (3-phase)',time:'~6.5 hrs'}] },
      { name: 'e:N Super',   from: 2024, to: 9999, connector: 'Type 2 + CCS',  maxKw: 11,   maxAmps: '16A (3-phase)', battery: 74,   search: 'Honda eN Super',
        speeds: [{kw:7.4,amps:'32A',time:'~10 hrs'},{kw:11,amps:'16A (3-phase)',time:'~7 hrs'}] },
      { name: 'CR-V e:PHEV', from: 2023, to: 9999, connector: 'Type 2',        maxKw: 7.4,  maxAmps: '32A (1-phase)', battery: 17.7, search: 'Honda CR-V PHEV',
        speeds: [{kw:2.3,amps:'10A',time:'~8 hrs'},{kw:7.4,amps:'32A',time:'~2.5 hrs'}] }
    ]}
  ];

  // ── Helpers ──────────────────────────────────────────────────────────────
  function getYearFromReg(raw) {
    var clean = raw.replace(/\s/g, '').toUpperCase();
    if (clean.length < 4) return null;
    var code = parseInt(clean.substring(2, 4), 10);
    if (isNaN(code)) return null;
    if (code >= 1  && code <= 49) return 2000 + code;
    if (code >= 51 && code <= 99) return 2000 + (code - 50);
    return null;
  }

  function showStep(n) {
    ['hfcStep1','hfcStep2','hfcStep3'].forEach(function(id, i) {
      var el = document.getElementById(id);
      if (el) el.style.display = (i + 1 === n) ? '' : 'none';
    });
  }

  function buildResults(model, regVal, year, makeKey) {
    var rows = model.speeds.map(function(s) {
      return '<tr><td>' + s.kw + ' kW</td><td>' + s.amps + '</td><td>' + s.time + '</td></tr>';
    }).join('');

    var yearStr = year ? (' · ' + year) : '';
    var searchUrl = '/collections/all/' + (makeKey || 'all');

    return '<div class="hfc-result-badge">' +
      (regVal ? '<div class="hfc-result-plate-mini">' + regVal.toUpperCase() + '</div>' : '') +
    '</div>' +
    '<div class="hfc-result-model">' + model.name + yearStr + '</div>' +
    '<div class="hfc-result-specs">' +
      '<div class="hfc-rspec"><span>Connector</span><strong>' + model.connector + '</strong></div>' +
      '<div class="hfc-rspec"><span>Max AC Charge</span><strong>' + model.maxKw + ' kW (' + model.maxAmps + ')</strong></div>' +
      '<div class="hfc-rspec"><span>Battery</span><strong>' + model.battery + ' kWh</strong></div>' +
    '</div>' +
    '<div class="hfc-table-label">Charging options (Type 2 cable)</div>' +
    '<table class="hfc-charge-table">' +
      '<thead><tr><th>Power</th><th>Charge Speed</th><th>Est. Full Charge</th></tr></thead>' +
      '<tbody>' + rows + '</tbody>' +
    '</table>' +
    '<a href="' + searchUrl + '" class="hfc-shop-btn">Shop ' + model.name + ' Cables &rarr;</a>';
  }

  // ── Init ─────────────────────────────────────────────────────────────────
  var regInput     = document.getElementById('hfcRegInput');
  var findBtn      = document.getElementById('hfcFindBtn');
  var hint         = document.getElementById('hfcRegHint');
  var modelsGrid   = document.getElementById('hfcModelsGrid');
  var modelsLabel  = document.getElementById('hfcModelsLabel');
  var resultContent= document.getElementById('hfcResultContent');
  var backBtn      = document.getElementById('hfcBackBtn');
  var backToMakes  = document.getElementById('hfcBackToMakes');
  if (!regInput) return;

  var currentYear = null;
  var autoTimer   = null;

  function showMakeSearch() {
    var step1 = document.getElementById('hfcStep1');
    if (!step1 || step1.querySelector('.hfc-make-search')) return;
    var orDiv = step1.querySelector('.hfc-or');
    var wrap = document.createElement('div');
    wrap.className = 'hfc-make-search';
    wrap.innerHTML = '<input type="text" id="hfcMakeSearch" placeholder="Type your car make, e.g. Honda…" autocomplete="off" autocapitalize="words">';
    if (orDiv) orDiv.parentNode.insertBefore(wrap, orDiv.nextSibling);
    var ms = document.getElementById('hfcMakeSearch');
    if (ms) {
      setTimeout(function() { ms.focus(); }, 50);
      ms.addEventListener('input', function() {
        var q = ms.value.trim().toLowerCase();
        document.querySelectorAll('.hfc-make').forEach(function(b) {
          var visible = !q || b.textContent.toLowerCase().indexOf(q) !== -1 || b.getAttribute('data-make').indexOf(q) !== -1;
          b.style.display = visible ? '' : 'none';
        });
      });
    }
  }

  function triggerSearch() {
    var val = regInput.value.trim();
    var year = getYearFromReg(val);
    currentYear = year;
    hint.innerHTML = '<span class="hfc-hint-searching">🔍 Looking up registration…</span>';
    setTimeout(function() {
      hint.innerHTML = year
        ? '<span class="hfc-hint-ok">✓ ' + year + ' registration found</span> — now select your make:'
        : '<span class="hfc-hint-ok">✓ Registration entered</span> — select your make:';
      showStep(1);
      var grid = document.getElementById('hfcMakesGrid');
      if (grid) {
        grid.classList.add('expanded');
        var smb = document.getElementById('hfcShowMoreMakes');
        if (smb) smb.style.display = 'none';
        grid.classList.remove('hfc-pulse');
        void grid.offsetWidth;
        grid.classList.add('hfc-pulse');
      }
      document.getElementById('hfcStep1').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 700);
  }

  // Live plate formatting + auto-trigger when full plate typed
  regInput.addEventListener('input', function() {
    regInput.value = regInput.value.replace(/[^a-zA-Z0-9\s]/g, '').toUpperCase();
    var clean = regInput.value.replace(/\s/g, '');
    clearTimeout(autoTimer);

    if (clean.length === 0) { hint.textContent = ''; currentYear = null; return; }

    var year = getYearFromReg(regInput.value);
    if (clean.length >= 7) {
      hint.innerHTML = year
        ? '<span class="hfc-hint-searching">✓ ' + year + ' plate — searching…</span>'
        : '<span class="hfc-hint-searching">Searching…</span>';
      autoTimer = setTimeout(triggerSearch, 700);
    } else if (year && clean.length >= 4) {
      hint.textContent = '✓ ' + year + ' reg — enter full plate to continue';
      currentYear = year;
    } else {
      hint.textContent = 'Format: AB12 CDE';
      currentYear = null;
    }
  });

  // Manual button still works too
  if (findBtn) findBtn.addEventListener('click', function() {
    var val = regInput.value.trim();
    if (!val) { hint.textContent = 'Please enter your registration number'; regInput.focus(); return; }
    clearTimeout(autoTimer);
    triggerSearch();
  });

  // Show more / fewer makes toggle
  var showMoreBtn = document.getElementById('hfcShowMoreMakes');
  if (showMoreBtn) {
    showMoreBtn.addEventListener('click', function() {
      var grid = document.getElementById('hfcMakesGrid');
      var expanded = grid.classList.toggle('expanded');
      showMoreBtn.textContent = expanded ? 'Show fewer makes ↑' : 'View all makes ↓';
    });
  }

  // Make button clicked → show model grid
  document.querySelectorAll('.hfc-make').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var makeKey = btn.getAttribute('data-make');
      var makeData = hfcCars.find(function(c) { return c.make === makeKey; });
      if (!makeData || !makeData.models.length) {
        window.location.href = '/collections/all/' + makeKey;
        return;
      }
      var models = makeData.models.filter(function(m) {
        return !currentYear || (currentYear >= m.from && currentYear <= m.to);
      });
      if (!models.length) models = makeData.models;

      modelsLabel.textContent = makeData.label + ' — select your model';
      modelsGrid.innerHTML = '';
      models.forEach(function(model) {
        var b = document.createElement('button');
        b.className = 'hfc-model-btn';
        b.textContent = model.name;
        b.addEventListener('click', function() {
          resultContent.innerHTML = buildResults(model, regInput.value.trim(), currentYear, makeKey);
          showStep(3);
        });
        modelsGrid.appendChild(b);
      });
      var allBtn = document.createElement('a');
      allBtn.href = '/collections/all/' + makeKey;
      allBtn.className = 'hfc-model-btn hfc-model-all';
      allBtn.textContent = 'All ' + makeData.label + ' cables';
      modelsGrid.appendChild(allBtn);
      showStep(2);
    });
  });

  // Back buttons
  if (backBtn)     backBtn.addEventListener('click', function() { showStep(1); });
  if (backToMakes) backToMakes.addEventListener('click', function() { currentYear = null; showStep(1); });

})();


// Mobile menu toggle
var mobileBtn = document.getElementById('mobileMenuBtn');
var mobileMenu = document.getElementById('mobileMenu');
if (mobileBtn && mobileMenu) {
  mobileBtn.addEventListener('click', function() {
    mobileMenu.classList.toggle('open');
    mobileBtn.textContent = mobileMenu.classList.contains('open') ? '✕' : '☰';
  });
}

// Search by Car dropdown (desktop)
var carBtn = document.getElementById('carDropdownBtn');
var carMenu = document.getElementById('carDropdownMenu');
if (carBtn && carMenu) {
  carBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    var isOpen = carMenu.classList.toggle('open');
    carBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
  document.addEventListener('click', function(e) {
    if (!carBtn.contains(e.target) && !carMenu.contains(e.target)) {
      carMenu.classList.remove('open');
      carBtn.setAttribute('aria-expanded', 'false');
    }
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      carMenu.classList.remove('open');
      carBtn.setAttribute('aria-expanded', 'false');
    }
  });
}

// Search by Car toggle (mobile)
var mobileCarToggle = document.getElementById('mobileCarToggle');
var mobileCarList = document.getElementById('mobileCarList');
if (mobileCarToggle && mobileCarList) {
  mobileCarToggle.addEventListener('click', function() {
    var isOpen = mobileCarList.classList.toggle('open');
    mobileCarToggle.textContent = isOpen ? 'Search by Car ▴' : 'Search by Car ▾';
  });
}

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(function(link) {
  link.addEventListener('click', function(e) {
    var target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

// Add to cart feedback (inner pages)
document.querySelectorAll('.add-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var form = btn.closest('form');
    if (!form) return;
    var original = btn.textContent;
    btn.textContent = '✓ Added!';
    btn.style.background = '#16a34a';
    setTimeout(function() {
      btn.textContent = original;
      btn.style.background = '';
    }, 2000);
  });
});

// Fade-in animation on scroll
(function() {
  var style = document.createElement('style');
  style.textContent = '.fade-in-up { opacity: 0; transform: translateY(24px); transition: opacity 0.55s ease, transform 0.55s ease; } .fade-in-up.visible { opacity: 1; transform: none; }';
  document.head.appendChild(style);

  var targets = document.querySelectorAll('.cat-card, .why-lp-card, .pp-card, .testi-card, .about-stat');
  targets.forEach(function(el) { el.classList.add('fade-in-up'); });

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  targets.forEach(function(el) { observer.observe(el); });
})();

// ── Related products on product page ────────────────────────────────────────
(function() {
  var grid = document.getElementById('pdRelatedGrid');
  if (!grid) return;
  var make = grid.getAttribute('data-make');
  var currentHandle = grid.getAttribute('data-handle');
  if (!make) { grid.innerHTML = ''; return; }
  fetch('/collections/all/' + make + '/products.json?limit=8')
    .then(function(r) { return r.ok ? r.json() : Promise.reject(); })
    .then(function(data) {
      var products = (data.products || []).filter(function(p) { return p.handle !== currentHandle; }).slice(0, 3);
      if (!products.length) { grid.innerHTML = ''; return; }
      grid.innerHTML = products.map(function(p) {
        var img1 = p.images[0] ? p.images[0].src : '';
        var img2 = p.images[1] ? p.images[1].src : '';
        var price = p.variants[0] ? (p.variants[0].price / 100).toFixed(2) : '';
        return '<a href="/products/' + p.handle + '" class="pd-rel-card">' +
          (img1 ? '<img src="' + img1 + '" class="pd-rel-car-img" alt="' + p.title + '" loading="lazy">' : '') +
          (img2 ? '<img src="' + img2 + '" class="pd-rel-cable-img" alt="cable" loading="lazy">' : '') +
          '<div class="pd-rel-body">' +
            '<div class="pd-rel-title">' + p.title + '</div>' +
            (price ? '<div class="pd-rel-price">£' + price + '</div>' : '') +
            '<span class="pd-rel-btn">View Product →</span>' +
          '</div></a>';
      }).join('');
    })
    .catch(function() { grid.innerHTML = ''; });
})();

// ── FAQ accordion ────────────────────────────────────────────────────────────
document.querySelectorAll('.pd-faq-q').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var item = btn.closest('.pd-faq-item');
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.pd-faq-item.open').forEach(function(i) { i.classList.remove('open'); });
    if (!isOpen) item.classList.add('open');
  });
});

// ── Sticky Add to Cart ───────────────────────────────────────────────────────
(function() {
  function initStickyBar() {
    var stickyBar = document.getElementById('pdStickyBar');
    if (!stickyBar) return;
    document.body.appendChild(stickyBar);
    stickyBar.style.transition = 'transform 0.3s ease';
    stickyBar.style.transform = 'translateY(100%)';

    var anchor = document.getElementById('pd-cart-form') || document.querySelector('.pd-add-btn');

    function checkSticky() {
      var shouldShow = anchor
        ? anchor.getBoundingClientRect().bottom < 0
        : window.scrollY > 300;
      stickyBar.style.transform = shouldShow ? 'translateY(0)' : 'translateY(100%)';
    }

    window.addEventListener('scroll', checkSticky, { passive: true });
    checkSticky();

    var mainSelect = document.getElementById('pdVariant');
    var stickyId = document.getElementById('pdStickyId');
    if (mainSelect && stickyId) {
      mainSelect.addEventListener('change', function() { stickyId.value = mainSelect.value; });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBar);
  } else {
    initStickyBar();
  }
})();

// ── Search overlay ───────────────────────────────────────────────────────────
(function() {
  var toggle = document.getElementById('searchToggle');
  var overlay = document.getElementById('searchOverlay');
  var closeBtn = document.getElementById('searchClose');
  var input = document.getElementById('searchInput');
  if (!toggle || !overlay) return;
  toggle.addEventListener('click', function() { overlay.classList.add('open'); if (input) setTimeout(function() { input.focus(); }, 50); });
  if (closeBtn) closeBtn.addEventListener('click', function() { overlay.classList.remove('open'); });
  overlay.addEventListener('click', function(e) { if (e.target === overlay) overlay.classList.remove('open'); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') overlay.classList.remove('open'); });
})();
